import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cc31144"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal"
}
const _hoisted_2 = { class: "content text-center" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"bg-gray-600\" data-v-5cc31144><h2 class=\"text-3xl p-5 text-white\" data-v-5cc31144>利用規約等の確認</h2></div><div class=\"border-2 border-gray-600 mb-3\" data-v-5cc31144></div><p data-v-5cc31144>サイトのご利用には以下の利用規約・ガイドラインへの同意が必要です。</p><p data-v-5cc31144>内容をご確認の上「同意して続行」ボタンをクリックしてください。</p><div class=\"mt-5\" data-v-5cc31144><a href=\"/terms\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"underline\" data-v-5cc31144>利用規約</a><br data-v-5cc31144><a href=\"/guideline\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"underline\" data-v-5cc31144>ガイドライン</a><br data-v-5cc31144></div>", 5)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isPopupVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("button", {
            class: "mt-8 bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleModal && _ctx.toggleModal(...args)))
          }, " 同意して続行 ")
        ])
      ]))
    : _createCommentVNode("", true)
}